import * as Constants from "../../utils/constants";
export const upadateShowToaster = () => {
  return {
    type: Constants.SHOW_TOASTER_VALUE,
  };
};
export const updateData = () => ({
  type: Constants.UPDATE_DATA,
});

export const loadData = (data: any) => ({
  type: Constants.LOAD_DATA,
  payload: data,
});
export const storeMyLoadsFilterCount = (data:any) => ({
  type: Constants.STORE_MYLOADS_FILTER_COUNT,
  payload: data,
});
export const carrierTenderedData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_CARRIERTENDERED_DATA,
  payload: { data, count , pageNumber},
});

export const loadCarrierData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_CARRIER_DATA,
  payload: { data, count ,pageNumber },
});


export const loadDeliveredNeedsPPWKData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_DELIVEREDNEEDSPPWK_DATA,
  payload: { data, count ,pageNumber},
});

export const loadDeliveredWithPPWKData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_DELIVEREDWITHPPWK_DATA,
  payload: { data, count ,pageNumber},
});
export const carrierAssignedLoads = (carierId: string) => ({
  type: Constants.FETCH_CARRIER_ASSIGNED_LOADS,
  payload: carierId,
});
export const AssignDriver = (requestDriverList: any) => ({
  type: Constants.ASSIGN_DRIVER,
  payload: requestDriverList,
});

export const SelectDriverList = (data: any) => ({
  type: Constants.ASSIGN_DRIVER_LIST,
  payload: data,
});

export const addDriverSuccess = (payload: any) => ({
  type: Constants.ADD_DRIVER_SUCCESS,
  payload,
});

export function assignDriverToShipment(payload: any, callback?: Function) {
  return {
    type: Constants.CarrierActionTypes.ASSIGN_DRIVER_TO_SHIPMENT,
    payload,
    callback,
  };
}

export function unAssignDriverToShipment(payload: any, callBack: Function) {
  return {
    type: Constants.CarrierActionTypes.UN_ASSIGN_DRIVER_TO_SHIPMENT,
    payload,
    callBack
  };
}

export function assignDriverToShipmentResponse(payload: any) {
  return {
    type: Constants.CarrierActionTypes.ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE,
    payload,
  };
}

export function unAssignDriverToShipmentResponse(payload: any) {
  return {
    type: Constants.CarrierActionTypes.UN_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE,
    payload,
  };
}

export const driverAssignedLoads = (carierId: string) => ({
  type: Constants.FETCH_DRIVER_ASSIGNED_LOADS,
  payload: carierId,
});

export const fetchMyLoads = (
  carrier: any,
  driver: any,
  hideLoader = false
) => ({
  type: Constants.FETCH_MYLOADS,
  payload: { isCarrier: carrier, isDriver: driver, hideLoader },
});

export const loadAssignedData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.DRIVER_ASSIGNED_DATA,
  payload: { data, count ,pageNumber},
});
export function clearAssignDriverToShipmentResponse() {
  return {
    type: Constants.CarrierActionTypes.CLEAR_ASSIGN_DRIVER_TO_SHIPMENT_RESPONSE,
  };
}

export const driverAssignedLoadsFromPush = (data: any) => ({
  type: Constants.FETCH_DRIVER_ASSIGNED_LOADS_FROM_PUSH,
  payload: data,
});

export const fetchShipments = (
  query: any,
  isHideLoader = false,
  callBack = () => null
) => ({
  type: Constants.SHIPMENT_LOADS,
  payload: { query, isHideLoader, callBack},
});
export const fetchShipmentsForDriverInManageUser = (
  query: any,
  isHideLoader = false,
  callBack = () => null
) => ({
  type: Constants.SHIPMENT_LOADS_MANAGE_USER,
  payload: { query, isHideLoader, callBack},
});

export const inTransitData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_INTRANSIT_DATA,
  payload: { data, count ,pageNumber}
});

export const DeliveryNeedsPPWKData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_DELIVEREDNEEDSPPWK_DATA,
  payload: { data, count ,pageNumber}
});
export const DeliveryWithPPWKData = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_DELIVEREDWITHPPWK_DATA,
  payload: { data, count ,pageNumber}
});
export const driverDataforManageUsers = (data: any, count: number,pageNumber?: number) => ({
  type: Constants.LOAD_DRIVER_DATA_MANAGE_USERS,
  payload: { data, count , pageNumber},
});


export const shipmentForStartTrip = (data: any) => {
  return {
    type: Constants.CarrierActionTypes.SHIPMENT_FOR_STARTTRIP,
    payload: data,
  };
};

export const shipmentForStartTripTimestamp = (timestamp: string) => {
  return {
    type: Constants.CarrierActionTypes.SHIPMENT_FOR_STARTTRIP_TIMESTAMP,
    payload: timestamp,
  };
};

export const startTrip = (data: any, callback?: Function) => ({
  type: Constants.CarrierActionTypes.START_TRIP,
  payload: data,
  callback,
});

export const startTripInformationResponse = (data: any) => ({
  type: Constants.CarrierActionTypes.START_TRIP_INFORMATION_RESPONSE,
  payload: data,
});

export const completeTripApiRequest = (data: any, shipmentId: string) => ({
  type: Constants.CarrierActionTypes.COMPLETE_TRIP_API_REQUEST,
  payload: {
    data,
    shipmentId,
  },
});

export const completeTripApiResponse = (data: any) => ({
  type: Constants.CarrierActionTypes.COMPLETE_TRIP_API_RESPONSE,
  payload: data,
});
export const deliveredData = (data: any, count: number) => ({
  type: Constants.LOAD_DELIVERED_DATA,
  payload: {
    data,
    count,
  },
});
export const deliveredWithPPWKData = (data: any, count: number) => ({
  type: Constants.LOAD_DELIVERED_DATA,
  payload: {
    data,
    count,
  },
});

export const getPredecessorShipment = (data: any,callBack?:any) => {
  return {
    type: Constants.CarrierActionTypes.GET_PREDECESSOR_SHIPMENT,
    payload: {data,callBack}
  }
}

export const getPredecessorShipmentResponse = (data: any) => {
  return {
    type: Constants.CarrierActionTypes.GET_PREDECESSOR_SHIPMENT_RESPONSE,
    payload: data
  }
}
/** POST-SUCCESSOR API ACTION */

export const successorShipmentResponse = (data: any) => ({
  type: Constants.CarrierActionTypes.SUCCESSOR_SHIPMENT_RESPONSE,
  payload: data,
});

export const clearSuccessorShipmentResponse = (data?: any) => ({
  type: Constants.CarrierActionTypes.CLEAR_SUCCESSOR_SHIPMENT_RESPONSE,
  payload: data
})

export const publishCarrierIntentMessage = (data: any) => ({
  type: Constants.CarrierActionTypes.CARRIER_INTENT_MESSAGE,
  payload: data,
})

export const publishCarrierIntentMessageResponse = (data: any) => ({
  type: Constants.CarrierActionTypes.CARRIER_INTENT_MESSAGE_RESPONSE,
  payload: data,
})

export const globalSearchdata = (data: any, bucket: string) => ({
  type: Constants.GLOBAL_SEARCH_LOADS_UPDATE,
  payload: { data, bucket}
});

export const reSendInviteForAssignDriver = (data:any) => ({
  type: Constants.RESEND_INVITE_ASSIGN_DRIVER,
  payload: data,
});